(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("WebCoreUi", [], factory);
	else if(typeof exports === 'object')
		exports["WebCoreUi"] = factory();
	else
		root["WebCoreUi"] = root["WebCoreUi"] || {}, root["WebCoreUi"]["sentryIntegration"] = factory();
})((typeof self !== 'undefined' ? self : this), () => {
return 